import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
} from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CustomButtonComponent } from '../../../../shared/components/custom-button/custom-button';
import {
  CustomModalComponent,
  ModalButton,
} from '../../../../shared/components/custom-modal/custom-modal';
import { CustomSearchComponent } from '../../../../shared/components/custom-search/custom-search';
import { CustomTooltipComponent } from '../../../../shared/components/custom-tooltip/custom-tooltip';
import { InputCustom } from '../../../../shared/components/input-custom/input-custom';
import { Router } from '@angular/router';
import { TableUtil } from '../../../../shared/utils/tableUtil';
import { Profile, SistemaResponse } from '../../models/perfil';
import { LoaderService } from '../../../../core/services/loader/loader-service';
import { PerfilService } from '../../services/perfil-config-service';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { ToastService } from '../../../../core/services/toast/toast-service';
import { Menu } from '../../../user/models/menu';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SystemsService } from '../../../dashboard/services/systems-service';
import { SystemResponse } from '../../../dashboard/models/SystemsModel';
import { MenuSystemService } from '../../../menu-system/services/menu-system-service';
import { CustomMultiselectComponent } from '../../../../shared/components/custom-multiselect/custom-multiselect';

@Component({
  selector: 'app-profile-config-page',
  imports: [
    MatCardModule,
    CommonModule,
    MatTableModule,
    MatSlideToggleModule,
    MatPaginatorModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    CustomSearchComponent,
    CustomButtonComponent,
    CustomModalComponent,
    InputCustom,
    ReactiveFormsModule,
    CustomTooltipComponent,
    MatInputModule,
    MatSelectModule,
    MatSortModule,
  ],
  templateUrl: './profile-config-page.html',
  styleUrl: './profile-config-page.css',
})
export class ProfileConfigPage {
  isOpenModal: boolean = false;
  editMode: boolean = false;
  menus: Menu[] = [];
  sistemas: SystemResponse[] = [];
  idCurrentProfile: number | null = null;
  dataSource: any;
  searchText: string = '';
  profiles: Profile[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort?: MatSort;

  displayedColumns: string[] = [
    'codigo',
    'nombre',
    'sistemas',
    'menus',
    'puertas',
    'accion',
  ];
  addProfileButtons: ModalButton[] = [
    {
      text: 'Agregar',
      variant: 'primary',
     variantCancel:'info',
      action: 'save',
    },
  ];

  editProfileButtons: ModalButton[] = [
    {
      text: 'Guardar cambios',
      variant: 'primary',
    variantCancel:'info',
      action: 'update',
    },
  ];

  profileForm = new FormGroup({
    codigo: new FormControl('', [Validators.required]),
    nombre: new FormControl('', [Validators.required]),
    sistemas: new FormControl<SistemaResponse[]>([], [Validators.required]),
    menus: new FormControl<Menu[]>([], [Validators.required]),
  });

  get nombreInput() {
    return this.profileForm.get('nombre');
  }
  get codigoInput() {
    return this.profileForm.get('codigo');
  }
  get sistemasInput() {
    return this.profileForm.get('sistemas');
  }
  get menusInput() {
    return this.profileForm.get('menus');
  }

  ngOnInit() {
    this.getAllProfiles();
    this.getSistemas();
    this.getMenus();
  }
  constructor(
    private systemsService: SystemsService,
    private router: Router,
    private loaderService: LoaderService,
    private profileService: PerfilService,
    private toastService: ToastService,
    private paginatorIntl: MatPaginatorIntl,
    private menuSystemService: MenuSystemService
  ) {
    this.paginatorIntl.itemsPerPageLabel = 'Filas por página:';
    this.paginatorIntl.lastPageLabel = 'Última página';
    this.paginatorIntl.firstPageLabel = 'Primera página';
    this.paginatorIntl.nextPageLabel = 'Página siguiente';
    this.paginatorIntl.previousPageLabel = 'Página anterior';

    this.paginatorIntl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number
    ) => {
      if (length === 0 || pageSize === 0) {
        return `0 de ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} de ${length}`;
    };
    this.paginatorIntl.changes.next();
  }

  getSisLabel(perfil: Profile) {
    let sis = Array.from(
      new Set(perfil.sistemas.map((item: SistemaResponse) => item.nombre))
    );
    let text = sis
      .map((x) => x)
      .join(',')
      .toString();
    return text;
  }

  navigateToMenu() {
    this.router.navigate(['/menu']);
  }

  onSearchKeyup(event: KeyboardEvent) {
    const target = event.target as HTMLInputElement;
    this.searchText = target.value;
    this.applyFilter(this.searchText);
  }
  applyFilter(searchText: string) {
    this.dataSource.filter = searchText.trim().toLowerCase();
  }

  getAllProfiles() {
    this.loaderService.showLoader();
    this.profileService.getAllProfiles().subscribe({
      next: (res) => {
        this.profiles = res;
        this.dataSource = new MatTableDataSource<Profile>(this.profiles);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.applyFilter(this.searchText);
        this.loaderService.hideLoader();
      },
      error: (err) => {
        console.error('Error fetching menus:', err);
        this.loaderService.hideLoader();
      },
    });
  }

  exportTable(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    let datos: any[] = [];
    this.profiles.forEach((element) => {
      let data = {
        Codigo: element.codigo,
        Nombre: element.nombre,
        Sistemas: element.sistemas.map((s) => s.nombre).join('\n\r'),
        Menus: element.menus.map((m) => m.titulo).join('\n\r'),
      };
      datos.push(data);
    });
    TableUtil.exportToExcelModel(datos);
  }

  closeModal() {
    this.isOpenModal = false;
    this.editMode = false;
    this.profileForm.reset();
  }
  openModal() {
    this.isOpenModal = true;
  }

  openEditModal(profile: Profile) {
    this.isOpenModal = true;
    this.editMode = true;
    this.idCurrentProfile = profile.id;
    this.profileForm.setValue({
      codigo: profile.codigo,
      nombre: profile.nombre,
      menus: profile.menus,
      sistemas: profile.sistemas,
    });
  }

  getMenus() {
    this.loaderService.showLoader();
    this.menuSystemService.findAll().subscribe({
      next: (res) => {
        this.menus = res;
        this.loaderService.hideLoader();
      },
      error: (err) => {
        console.error('Error fetching menus:', err);
        this.toastService.showToast(
          'Error al cargar los menús. Por favor, inténtelo de nuevo más tarde.',
          'error'
        );
        this.loaderService.hideLoader();
      },
    });
  }

  getSistemas() {
    this.loaderService.showLoader();
    this.systemsService.fetchSystemsData().subscribe({
      next: (res) => {
        this.sistemas = res;
        this.loaderService.hideLoader();
      },
      error: (err) => {
        console.error('Error fetching sistemas:', err);
        this.toastService.showToast(
          'Error al cargar los sistemas. Por favor, inténtelo de nuevo más tarde.',
          'error'
        );
        this.loaderService.hideLoader();
      },
    });
  }

  submitProfileForm() {
    if (this.profileForm.invalid) {
      this.profileForm.markAllAsTouched();
      return;
    }
    this.loaderService.showLoader();

    let profileData = {
      codigo: this.profileForm.value.codigo!.trim(),
      nombre: this.profileForm.value.nombre!.trim(),
      sistemas: this.profileForm.value.sistemas?.map(
        (sistema: SistemaResponse) => ({
          id: sistema.id,
        })
      ),
      menus: this.profileForm.value.menus?.map((menu: Menu) => ({
        codigoMenu: menu.codigoMenu,
      })),
    };

    if (this.editMode && this.idCurrentProfile) {
      this.profileService
        .update({ ...profileData, id: this.idCurrentProfile })
        .subscribe({
          next: (res) => {
            this.loaderService.hideLoader();
            this.getAllProfiles();
            this.toastService.showToast(
              'Perfil actualizado exitosamente.',
              'success'
            );
            this.closeModal();
          },
          error: (err) => {
            this.loaderService.hideLoader();
            console.error('Error updating perfil:', err);
            this.toastService.showToast(
              'Error al actualizar el perfil. ',
              'error'
            );
            this.closeModal();
          },
        });
    } else {
      this.profileService.create(profileData).subscribe({
        next: (res) => {
          this.loaderService.hideLoader();
          this.getAllProfiles();
          this.toastService.showToast('Perfil creado exitosamente.', 'success');
          this.closeModal();
        },
        error: (err) => {
          this.loaderService.hideLoader();
          console.error('Error creating perfil:', err);
          this.toastService.showToast('Error al crear el perfil. ', 'error');
          this.closeModal();
        },
      });
    }
  }

  getCantSis(perfil: Profile) {
    let sis = Array.from(
      new Set(perfil.sistemas.map((item: SistemaResponse) => item.id))
    );
    return sis.length;
  }
  getCantMenu(perfil: Profile) {
    let menus = Array.from(
      new Set(perfil.menus.map((item: Menu) => item.codigoMenu))
    );
    return menus.length;
  }

  getMenuLabel(perfil: Profile) {
    let menus = Array.from(
      new Set(perfil.menus.map((item: Menu) => item.titulo))
    );
    let text = menus
      .map((x) => x)
      .join(', ')
      .toString();
    return text;
  }
  compareMenus(menu1: Menu, menu2: Menu): boolean {
    return menu1 && menu2
      ? menu1.codigoMenu === menu2.codigoMenu
      : menu1 === menu2;
  }

  compareSistemas(
    sistema1: SistemaResponse,
    sistema2: SistemaResponse
  ): boolean {
    return sistema1 && sistema2
      ? sistema1.id === sistema2.id
      : sistema1 === sistema2;
  }
}
